var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/clock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 14.2188C3.79375 14.2188 0.78125 11.2062 0.78125 7.5C0.78125 3.79375 3.79375 0.78125 7.5 0.78125C11.2062 0.78125 14.2188 3.79375 14.2188 7.5C14.2188 11.2062 11.2062 14.2188 7.5 14.2188ZM7.5 1.71875C4.3125 1.71875 1.71875 4.3125 1.71875 7.5C1.71875 10.6875 4.3125 13.2812 7.5 13.2812C10.6875 13.2812 13.2812 10.6875 13.2812 7.5C13.2812 4.3125 10.6875 1.71875 7.5 1.71875Z",
    fill: "#FF6300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.81865 9.95626C9.7374 9.95626 9.65615 9.93751 9.58115 9.88751L7.64365 8.73126C7.1624 8.44376 6.80615 7.81251 6.80615 7.25626V4.69376C6.80615 4.43751 7.01865 4.22501 7.2749 4.22501C7.53115 4.22501 7.74365 4.43751 7.74365 4.69376V7.25626C7.74365 7.48126 7.93115 7.81251 8.1249 7.92501L10.0624 9.08126C10.2874 9.21251 10.3562 9.50001 10.2249 9.72501C10.1312 9.87501 9.9749 9.95626 9.81865 9.95626Z",
    fill: "#FF6300"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f83d9ebd72806e62c9c013687c82cfaf.svg";
export { ForwardRef as ReactComponent };